import { Controller } from '@hotwired/stimulus'

// Move targeted modal to the end of the body
export default class ModalPortalController extends Controller {
  // When applying the modal-portal-target attribute to a modal
  // Every connect callback on stimulus controller inside the modal will be triggered twice
  // Check if it creates any issue and if so, check how it has been fixed in ClipboardController
  static targets = ['modal'];

  modalTargetConnected(target) {
    document.body.append(target);
  }
}
